import { replaceLink } from "components/CodeSystemPanel/utils";
import { CodeSystem } from "context/elasticsearch/types";
import parse, {
  type Element,
  type HTMLReactParserOptions
} from "html-react-parser";
import { Row } from "react-bootstrap";
import { formatDate } from "utils";

type ParseContentProps = {
  content: string;
  headline?: string;
  isDate?: boolean;
  codeSystem: CodeSystem;
};

const ParseContent = ({
  content,
  headline,
  isDate,
  codeSystem
}: ParseContentProps) => {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => replaceLink(domNode as Element, codeSystem)
  };
  return (
    <Row className={`${headline && "flex-column"} p-0`}>
      {headline && <section className="fw-bold p-0">{headline}</section>}

      {isDate ? (
        <section className="p-0">{parse(formatDate(content))}</section>
      ) : (
        <section className="p-0">{parse(content, options)}</section>
      )}
    </Row>
  );
};

export default ParseContent;
